export default {
    BTC: {
        icon: "cc BTCP",
        color: "#F7931A"
    },
    ETH: {
        icon: "cc ETC",
        color: "#343434"
    },
    USDT: {
        icon: "cc USDT-alt",
        color: "#50AF95"
    },
    USDC: {
        icon: "usdc",
        color: "#2772CB"
    }
};
